import React, { Component } from "react";
import Cookies from 'js-cookie';
import Header from './Header'
import {GetRecents, ShrinkNumber} from '../util/Helper'
import RecentCard from '../components/RecentCard'
import Logo_MarketCap from "../img/ico/round_policy.png"
import Logo_Industry from "../img/ico/round_industry.png"
import Icon_Cloud from "../img/ico/round_cloud.png"
import Icon_Analytics from "../img/ico/round_analytics.png"
import Icon_Benchmarking from "../img/ico/round_benchmarking.png"
const queryString = require('query-string');


class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recents:null,
    };
    //defaults.plugins.legend.position = "right";
    
    //document.title = "Home"
}

componentDidMount() {
  /*****Cookie*****/
  try{
    var recents = GetRecents();
    this.setState({recents})
  }
  catch(err){

  }
  
 
  /***Query String******/
  //console.log(queryString.parse(this.props.location.search));
  /**** */
  

}



  render() {
    /*

        <label className="sectionTitle">Shortcuts</label>
        <div className="cardRow ">
          <a className="card ctaCard">
            <span>My Policies</span>
          </a>
          <a className="card ctaCard" style={{backgroundColor:'#8B80F9'}}>
            <span>Add Tower</span>
          </a>
          <a className="card ctaCard" style={{backgroundColor:'#58a2ec'}}>
            <span>Something Else</span>
          </a>
        </div>
        */
    

    return (
      <div>
        <Header title="Home"/>
        <div className="cardRow">
          <div className="card infoCard">
            <span className="infocardTitle">Total Limit</span>
            <span className="infocardValue">${ShrinkNumber(this.props.org.totalLimit)}</span>
          </div>
          <div className="card infoCard">
            <span className="infocardTitle">Policy Count</span>
            <span className="infocardValue">{this.props.org.policyCount}</span>
          </div>
          <div className="card infoCard">
            <span className="infocardTitle">Total Premium</span>
            <span className="infocardValue">${ShrinkNumber(this.props.org.totalPremium)}</span>
          </div>
        </div>
        {this.state.recents && 
        <>
        <label className="sectionTitle">Recently Viewed</label>
        <div className="cardRow scrollOutter">
          <div className="scrollInner">
            {this.state.recents.map((item, index) => {
              return <RecentCard item={item}/>
            })}
          </div>
        </div>
        </>
        }

        <>
        <div id="gettingStarted" className="card fullTable">
          <h1>Welcome to BinderDrop!</h1>
          <h2>Accelerate your business with the only data platform purpose built for the commercial insurance Industry that will help unlock the value of your portfolio and marketplace data.</h2>
        
          <div className="cardRow">
            <div className="card claim">
              <img src={Icon_Cloud}/>
              <span className="claimTitle">One Cloud<br/>Platform</span>
              <span className="claimDesc">Easily consolidate all of your data in one secure location.</span>
            </div>
            <div className="card claim">
              <img src={Icon_Analytics}/>
              <span className="claimTitle">Turnkey<br/> Analytics</span>
              <span className="claimDesc">In depth out of the box analytics functionality built for brokers and insurers</span>
            </div>
            <div className="card claim">
              <img src={Icon_Benchmarking}/>
              <span className="claimTitle">Dynamic <br/>Benchmarking</span>
              <span className="claimDesc">Instantly expand your benchmarking capabilities utilizing extensive portfolio, marketplace and 3rd party data analytics to drive insights and profitability</span>
            </div>
          </div>
        </div>
        </>
        
      </div>
      
    );
  }
}
 
export default Home;